export default __webpack_public_path__ + "static/media/p1h.db7885ec.png";